<template>
  <div class="my-custom">
    <div class="custom-top">
      <div class="top-header">
        <img :src="userInfo.headimgurl" class="img-head" alt="">
        <div class="head-con">
          <div class="name">{{ userInfo.nickname }}</div>
          <div class="tag" @click="handleJump('PAGECARD')">
            查看我的卡包
            <img src="@/assets/images_member/icon-return.png" class="icon" alt="">
          </div>
        </div>
      </div>
      <div class="flex-nav">
        <div class="item-nav">
          <div class="num status">{{ cusotmObject.all }}</div>
          <div class="txt">共成功邀请(人)</div>
        </div>
        <div class="item-nav">
          <div class="num">{{ cusotmObject.pay }}</div>
          <div class="txt">消费用户(人)</div>
        </div>
        <div class="item-nav">
          <div class="num">{{ cusotmObject.not_pay }}</div>
          <div class="txt">未消费用户(人)</div>
        </div>
      </div>
    </div>
    <div class="title">
      <div class="title-item cur">客户列表</div>
      <!-- <div class="title-item">会员</div> -->
    </div>
    <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad" class="list">
      <div class="item" v-for="(item, index) in list" :key="index" @click="handleJump(item)">
        <img :src="item.headimgurl" class="item-cover" alt="">
        <div class="item-con">
          <div class="txt-div">
            <div class="txt1">{{ item.nickname }}</div>
            <div class="txt2">¥{{ item.all_pay }}</div>
          </div>
          <div class="txt-div">
            <div class="txt3">{{ item.create_time }} 注册</div>
            <div class="txt3">共消费金额(元)</div>
          </div>
        </div>
        <img src="@/assets/images_member/per1 (53).png" class="item-arrow" alt="">
      </div>
    </van-list>
  </div>
</template>
<script>
import { cusotm, cusotmList } from '@/api/person'
export default {
  name: 'myCuston',
  data () {
    return {
      userInfo: {},
      cusotmObject: {},
      list: [],
      loading: false,
      finished: false,
      page: 1,
      num: 10
    }
  },

  mounted () {
    this.userInfo = JSON.parse(this.$ls.storage['xingfugongshe_user-info']).value
    this.handleFunction()
  },

  methods: {
    handleFunction () {
      cusotm().then(res => {
        this.cusotmObject = res.data
      })
    },
    onLoad() {
      cusotmList({
        page: this.page,
        num: this.num
      }).then(res => {
        console.log(res)
        if (res.data.length < this.num) {
          this.finished = true
        }
        this.list = this.list.concat(res.data)
        this.page++
        // 加载状态结束
        this.loading = false
      })
    },
    handleJump (item) {
      if (item === 'PAGECARD') {
        this.$router.push({
          path: '/pageCard'
        })
        return
      }
      this.$router.push({
        path: `/customDetails?id=${item.id}`
      })
    }
  }
}
</script>

<style lang="less" scoped>
.my-custom {
  background-color: #1E2020;
  min-height: 100vh;
  width: 100vw;
  padding: 14px;
  box-sizing: border-box;

  .custom-top {
    background-color: #292B2A;
    border-radius: 6px;

    .top-header {
      display: flex;
      align-items: center;
      padding: 20px 14px;
      box-sizing: border-box;

      .img-head {
        width: 60px;
        height: 60px;
        margin-right: 10px;
        border-radius: 50%;
        object-fit: cover;
      }

      .name {
        color: #F0E1C0;
        font-size: 20px;
        font-weight: 600;
        line-height: 20px;
        margin-bottom: 12px;
      }

      .tag {
        text-align: center;
        color: #CCCCCC;
        font-size: 12px;
        box-sizing: border-box;
        display: flex;
        align-items: center;
        .icon {
          width: 5px;
          height: 10px;
          margin-left: 6px;
          display: block;
        }
      }
    }

    .flex-nav {
      display: flex;
      align-items: center;
      justify-content: space-between;
      height: 84px;
      margin: 0 14px;
      border-top: 1px dashed #666666;

      .item-nav {
        display: flex;
        flex-direction: column;
        align-items: center;

        .num {
          font-size: 20px;
          color: #FFFFFF;
          line-height: 20px;
          margin-bottom: 12px;
          font-weight: 500;

          &.status {
            color: #F0E1C0;
          }
        }

        .txt {
          color: #999999;
          font-size: 12px;
          line-height: 12px;
        }
      }
    }
  }

  .title {
    position: relative;
    height: 64px;
    line-height: 64px;
    display: flex;

    .title-item {
      color: #FFFFFF;
      font-size: 16px;
      font-weight: 400;
      margin-right: 25px;

      &.cur {
        font-size: 18px;
        color: #F0E1C0;
        font-weight: 600;
        position: relative;

        &::after {
          position: absolute;
          bottom: 10px;
          width: 80%;
          height: 2px;
          background-color: #F0E1C0;
          left: 10%;
          content: "";
        }
      }
    }

  }

  .list {
    background-color: #292B2A;
    border-radius: 6px 6px 0px 0px;
    padding: 0 14px;
    box-sizing: border-box;

    .item {
      padding: 20px 0;
      box-sizing: border-box;
      border-bottom: 1px solid #666666;
      display: flex;
      justify-content: space-between;
      align-items: center;

      &:last-child {
        border: none;
      }

      .item-cover {
        width: 40px;
        height: 40px;
        border-radius: 50%;
        object-fit: cover;
        margin-right: 8px;
      }

      .item-arrow {
        width: 8px;
        height: 16px;
        margin-left: 8px;
      }

      .item-con {
        flex: 1;

        .txt-div {
          display: flex;
          justify-content: space-between;
          align-items: center;
          line-height: 16px;

          .txt1 {
            font-size: 16px;
            color: #FFFFFF;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          }

          .txt2 {
            font-size: 16px;
            color: #F0E1C0;
          }

          .txt3 {
            font-size: 12px;
            color: #999999;
            line-height: 8px;
            margin-top: 8px;
          }
        }
      }

    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/personal/custom.vue